import { useEffect } from 'react'
import { useGetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty } from '@/api/generated/company-management-user/company-management-user'
import type { LocalizationEntityType } from '@/api/model/localizationEntityType'
import { TranslateButton } from './TranslateButton'
import type { PlannedLanguages } from "@/components/common/translations/types.ts"

interface Props {
  entityType: LocalizationEntityType
  entityId: string
  /** Formatted backend property, nested ids already substituted. */
  property: string
  /** Buffered value from `useNestedTranslations`; falls back to what is stored on the server. */
  edited?: Record<string, string>
  onChange: (translations: Record<string, string>) => void
  dialogTitle?: string
  plannedLanguages?: PlannedLanguages
  onPlannedChange?: (planned: PlannedLanguages) => void
  autoTranslateAll?: boolean
  onLoaded?: (translations: Record<string, string>) => void
}

/**
 * TranslateButton for a nested property (e.g. a subtype field). Owns its own query instead of
 * being fed by `useEntityTranslations`: which nested properties exist changes while editing, so
 * a fixed `useQueries` list doesn't fit. Editing itself stays buffered in the parent form.
 */
export function NestedTranslateButton({ entityType, entityId, property, edited, onChange, dialogTitle, plannedLanguages, onPlannedChange, autoTranslateAll, onLoaded }: Props) {
  const { data } = useGetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty(entityType, entityId, property)
  const loaded = (data?.data as Record<string, string> | undefined) ?? {}

  useEffect(() => {
    if (data?.data) onLoaded?.(data.data as Record<string, string>)
  }, [data])

  return (
    <TranslateButton
      dialogTitle={dialogTitle}
      value={edited ?? loaded}
      onChange={onChange}
      plannedLanguages={plannedLanguages}
      onPlannedChange={onPlannedChange}
      autoTranslateAll={autoTranslateAll}
    />
  )
}
